export default __webpack_public_path__ + "static/media/spinner-logo.c6031714.svg";